export default function Footer() {
  return (
    <footer className="bg-[#121316] text-white text-sm py-12 px-6 font-sans">
      <div className="max-w-screen-xl mx-auto space-y-10">
        {/* Logo and Info */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 text-gray-300 w-full border-b border-gray-700 pb-8">
          <div className="flex-shrink-0">
            <h1 className="text-4xl font-bold leading-tight">Palette A.LAB</h1>
          </div>
        </div>
        {/* Branches */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 text-gray-300 w-full">
          <div>
            <p className="text-gray-500 mb-1">상호명</p>
            <p>팔레트 주식회사</p>
          </div>
          <div>
            <p className="text-gray-500 mb-1">전화번호</p>
            <p>010-5152-9181</p>
          </div>
          <div>
            <p className="text-gray-500 mb-1">사업자번호</p>
            <p>354-88-00939</p>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-8 border-b border-gray-700 pb-8">
          <div>
            <h4 className="text-gray-400 font-medium mb-2">본사</h4>
            <p className="text-white">
              서울특별시 강남구 논현로161길 51, B1~4층 (신사동, 라온빌딩)
            </p>
          </div>
          <div>
            <h4 className="text-gray-400 font-medium mb-2">Singapore Branch</h4>
            <p className="text-white">
              8 Marina View #39-04, Asia Square Tower 1,
              <br />
              Singapore 018960
            </p>
          </div>
          <div>
            <h4 className="text-gray-400 font-medium mb-2">India Branch</h4>
            <p className="text-white">
              8th Floor (Enzyme Managed Office), Block 3B,
              <br />
              Bhartiya Centre of IT, Thanisandra Main Road,
              <br />
              Bangalore, Karnataka, India 560064
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
